import { hasDismissedData, saveDismissData } from "../data";
import { AdBlockerType, DismissData } from "../types";
import { sendEvent } from "../utils";

export const onDismiss = (
  dismissData: DismissData,
  detectedExtension: AdBlockerType
) => {
  if (!hasDismissedData()) {
    saveDismissData(dismissData);
    sendEvent({
      ...dismissData,
      event: "dismiss",
      detectedExtension,
    });
  }
};
